import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, Flex, Divider, Link} from '@chakra-ui/react'
import i18next from 'i18next'
import {useTranslation, Trans} from 'react-i18next'

import PaymentsTable from '../../../components/PaymentsTable'

const RECONCILE_HELP_URL =
  'https://marmalade.ladesk.com/665857-How-to-reconcile-your-bill-payments-in-Xero'

export const PaymentActivityTab = ({supplierId}) => {
  i18next.loadNamespaces('pointsOnPayments')
  const {t} = useTranslation()

  return (
    <Box id="paymentactivity-tab" display="flex" flexDirection="column">
      <Flex direction="column" gap="sm" mt="md">
        <Flex justify="space-between">
          <Text textStyle="headline3" color="black">
            <Flex alignItems="center" gap="xs">
              {t('pointsOnPayments:bill.tabs.paymentActivity.subTitle')}
            </Flex>
          </Text>
        </Flex>

        <Flex>
          <Text textStyle="body-small" color="gray.500">
            <Trans
              t={t}
              i18nKey="pointsOnPayments:bill.tabs.paymentActivity.smallGrayText"
              components={{
                Link: (
                  <Link
                    href={RECONCILE_HELP_URL}
                    isExternal
                    variant="primary"
                    color="gray.500"
                  />
                ),
              }}
            />
          </Text>
        </Flex>
      </Flex>

      <Divider my="sm" mb={0} />

      <PaymentsTable supplierId={supplierId} />
    </Box>
  )
}

PaymentActivityTab.propTypes = {
  supplierId: PropTypes.string.isRequired,
}

export default PaymentActivityTab
